export const scrollAreaStyles = {
  scrollArea: 'relative',
  scrollAreaViewport:
    'focus-visible:ring-ring/50 size-full transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:outline-1',
  scrollBarBase: 'flex touch-none p-px transition-colors select-none',
  scrollBarVertical: 'h-full w-2.5 border-l border-l-transparent',
  scrollBarHorizontal: 'h-2.5 flex-col border-t border-t-transparent',
  scrollAreaThumb: 'bg-border relative flex-1 rounded-full',
} as const;
